import { render, staticRenderFns } from "./ServiceOrganizationFiling.vue?vue&type=template&id=aaea54bc&"
import script from "./ServiceOrganizationFiling.vue?vue&type=script&lang=js&"
export * from "./ServiceOrganizationFiling.vue?vue&type=script&lang=js&"
import style0 from "./ServiceOrganizationFiling.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports